module.exports = __webpack_public_path__ + "img/ceo-office.af9e5e03.jpg";